import router from '../router'
import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import { serialize } from 'object-to-formdata'
/*
    Guardar los datos de una preafiliacion
    para envio posterior a API
 */
Vue.use(Vuex)

/*
    Tiempo maximo de espera del envio de la afiliacion (3 minutos).
    El POST sube todos los adjuntos (DNI, titulo, certificados, fotos) en un
    unico multipart, por lo que necesita mucho mas margen que una request comun.
    Sin un timeout explicito axios espera indefinidamente: si la respuesta nunca
    llega, la promesa no se resuelve y la vista queda con el overlay de carga
    para siempre.
 */
const TIMEOUT_ENVIO_AFILIACION = 180000

/*
    Traduce un error de axios al mensaje que ve la afiliada.
    El motivo del fallo cambia la accion que puede tomar: no es lo mismo una
    conexion caida que archivos demasiado pesados o un error del servidor.
 */
function mensajeErrorEnvioAfiliacion(error) {
    if (error.code === 'ECONNABORTED') {
        return {
            success: false,
            msg: 'El envío tardó demasiado y se interrumpió. Puede deberse a una conexión lenta o a que los archivos adjuntos son muy pesados. Verificá tu conexión e intentá nuevamente.',
            detalle: [],
        }
    }

    if (!error.response) {
        return {
            success: false,
            msg: 'No pudimos comunicarnos con el servidor. Revisá tu conexión a internet e intentá nuevamente.',
            detalle: [],
        }
    }

    if (error.response.status === 413) {
        return {
            success: false,
            msg: 'Los archivos adjuntos superan el tamaño permitido por el servidor. Volvé a cargarlos con menor resolución e intentá nuevamente.',
            detalle: [],
        }
    }

    return {
        success: false,
        msg: `Hubo un error al enviar la solicitud (código ${error.response.status}). Si el problema persiste, comunicate con tu Delegación Distrital.`,
        detalle: [],
    }
}

export default ({
    namespaced: true,

    state: {
        //**
        //  Formuiario de preafiliacion (GENERAL)
        //**
        preafi: false,
        matricula: '',
        nrodoc: '',
        fototmp: '',
        //Flag para mostrar formulario de conyuge
        cargaConyuge: false,
        //Flag para mostrar formulario profesionales
        necesitaHistorial: false,
        //Flag para mostrar consulta nivel
        tipoAporteRed: '',
        totalAnios: [],
        tablaAporteReducido: [],
        resumen: [],
        reconsidera: false,
        objNivel: [],
        itemReduce: [],
        aporteReducido: false,

        //**
        //   FormPreAfi.vue 
        //** */ 
        datosPersonales: {
            fotocarnet: '',
            feccud: '1900-01-01',
            fecdisc: '1900-01-01',
        },
        fotocarnet: '',
        cantHijos: '',
        //Archivos FormPreAfi.vue
        dniFrentePreAfiliado: [],
        dniDorsoPreAfiliado: [],
        datosPadres: {},


        //**
        // FormPreHijos.vue
        //  */
        datosHijos: [],
        //Archivos FormPreHijos.vue
        archivosHijos: [],


        //** 
        // FormConyuge.vue
        // */
        datosFamiliares: {},
        //Archivos FormConyuge.vue
        dniFrenteFamiliar: [],
        dniDorsoFamiliar: [],
        certMatConConvFamiliar: [],


        //**
        // FormPreCopntactos.vue
        //  */        
        datosContacto: {},


        //**
        // FormPreProfesionales.vue
        // */
        datosProfesionales: {
            fecmat: '',
            fectit: '',
        },
        //Archivos FormPreProfesionales.vue
        titFrenteAfiliado: [], //Titulo Profesional frente
        titDorsoAfiliado: [], //Titulo Profesional dorso
        histMatricula: [], //Historial de matricula
        certMatricula: [], //Alta matricula del colegio de psi


        //**
        // FormDiscapacidad.vue
        // */
        certDisc: [],


        //**
        // FormPreNivel.vue
        // */
        datosNivel: {},
        // Archivos FormPreNivel.vue
        reciboSueldo: [],       //Recibo de sueldo
        certLaboral: [],



        //**
        //Para poder visualizar en FormularioVista.vue
        //  */
        //datosFamiliaresVista: [],
        //datosContactoTelVista: [],
        //datosContactoEmailVista: [],
        //datosContactoDomVista: [],


        //fecafil: '',
        //idEstadoCivil: '',
        //fechaEstadoCivil: '',
        //fechas para calcular items de opcion de nivel
        //fecnacim: '',
        formData: {},
        resPreAfiliacion: '',

    },

    getters: {
        cantHijos(state) {
            return state.cantHijos
        },
        archivosHijos(state) {
            return state.archivosHijos
        },
        cargaConyuge(state) {
            return state.cargaConyuge
        },
        necesitaHistorial(state) {
            return state.necesitaHistorial
        },
        fechaestadocivil(state) {
            return state.datosPersonales.fecestadocivil
        },
        tipoAporteRed(state) {
            return state.tipoAporteRed
        },
        dniFrentePreAfiliado(state) {
            return state.dniFrentePreAfiliado
        },
        dniDorsoPreAfiliado(state) {
            return state.dniDorsoPreAfiliado
        },
        dniFrenteFamiliar(state) {
            return state.dniFrenteFamiliar
        },
        dniDorsoFamiliar(state) {
            return state.dniDorsoFamiliar
        },
        certMatConConvFamiliar(state) {
            return state.certMatConConvFamiliar
        },
        certDisc(state) {
            return state.certDisc
        },
        titFrenteAfiliado(state) {
            return state.titFrenteAfiliado
        },
        titDorsoAfiliado(state) {
            return state.titDorsoAfiliado
        },
        certMatricula(state) {
            return state.certMatricula
        },
        histMatricula(state) {
            return state.histMatricula
        },
        reciboSueldo(state) {
            return state.reciboSueldo
        },
        certLaboral(state) {
            return state.certLaboral
        },
        fotoCarnet(state) {
            return state.fotocarnet
        },
        preafi(state) {
            return state.preafi
        },
        objNivel(state) {
            return state.objNivel
        },
        resumen(state) {
            return state.resumen
        },
        reconsidera(state) {
            return state.reconsidera
        },
        tablaAporteReducido(state) {
            return state.tablaAporteReducido
        },
        totalAnios(state) {
            return state.totalAnios
        },
        fototmp(state) {
            return state.fototmp
        },
        datosPersonales(state) {
            return state.datosPersonales
        },
        datosHijos(state) {
            return state.datosHijos
        },
        datosContacto(state) {
            return state.datosContacto
        },
        datosFamiliares(state) {
            return state.datosFamiliares
        },
        datosPadres(state) {
            return state.datosPadres
        },
        datosDiscapacidad(state) {
            return state.datosDiscapacidad
        },
        datosNivel(state) {
            return state.datosNivel
        },
        datosProfesionales(state) {
            return state.datosProfesionales
        },
        itemNivel(state) {
            return state.itemNivel
        },
        matricula(state) {
            return state.matricula
        },
        aporteReducido(state) {
            return state.aporteReducido
        },
        tablaAporteReducido(state) {
            return state.tablaAporteReducido
        },
        hayFotoCarnetCargada(state) {
            return (state.fotocarnet.length !== 0)
        },
        hayFotoCarnet(state) {
            return (state.datosPersonales.fotocarnet !== '')
        },
        fotocarnet(state) {
            return state.datosPersonales.fotocarnet
        },
        nrodoc(state) {
            return state.nrodoc
        },
        itemReduce(state) {
            return state.itemReduce
        },
        resPreAfiliacion(state) {
            return state.resPreAfiliacion
        },
        itemsDatosPersonales(state) {
            if (Object.keys(state.datosPersonales).length > 4) {
                return [
                    { "NOMBRE Y APELLIDO": `${state.datosPersonales.nombres} ${state.datosPersonales.apellido}` },
                    { "DNI": state.datosPersonales.nrodoc },
                    { "CUIL": state.datosPersonales.cuil },
                    { "SEXO": state.datosPersonales.sexo },
                    { "FECHA DE NACIMIENTO": state.datosPersonales.fecnacim },
                    { "ESTADO CIVIL": state.datosPersonales.desestadocivil },
                    { "FECHA ESTADO CIVIL": state.datosPersonales.fecestadocivil },
                    { "NACIONALIDAD": state.datosPersonales.desnacionalidad },
                    { "TIPO DE NACIONALIDAD": state.datosPersonales.destipnacionalidad }
                ]
            } else return []
        },
        itemsDatosContacto(state) {
            if (Object.keys(state.datosContacto).length > 0) {
                return [
                    { "NRO. TELEFÓNICO": `+${state.datosContacto.telefono.codpais} (${state.datosContacto.telefono.carac}) - ${state.datosContacto.telefono.telefono} ` },
                    { "TIPO DE TELEFONO": state.datosContacto.telefono.destiptelefono },
                    { "EMPRESA": state.datosContacto.telefono.destipcarrier },
                    { "EMAIL": state.datosContacto.email.email },
                    { "DIRECCIÓN": `${state.datosContacto.domicilio.calle} Nº ${state.datosContacto.domicilio.nro} ${state.datosContacto.domicilio.piso} ${state.datosContacto.domicilio.dep}` },
                    { "PROVINCIA": ((state.datosContacto.domicilio.codprov) !== 1) ? `${state.datosContacto.domicilio.desprov}` : '' },
                    { "LOCALIDAD": state.datosContacto.domicilio.localidad },
                    { "COD. POSTAL": state.datosContacto.domicilio.cp },
                ]
            } else return []
        },
        itemsDatosFamiliares(state) {
            if (Object.keys(state.datosFamiliares).length > 0) {
                return [
                    { "NOMBRE Y APELLIDO": `${state.datosFamiliares.nombres} ${state.datosFamiliares.apellido}` },
                    { "DNI": state.datosFamiliares.nrodoc },
                    { "SEXO": state.datosFamiliares.sexo },
                    { "FECHA DE NACIMIENTO": state.datosFamiliares.fecnacim },
                    { "NACIONALIDAD": state.datosFamiliares.desnacionalidad },
                    { "TIPO DE NACIONALIDAD": state.datosFamiliares.destipnacionalidad },
                    { "FECHA DE FALLECIMIENTO": state.datosFamiliares.fecfallecido },
                    // { "DISCAPACIDAD": ((state.datosFamiliares.destipnacionalidad) == 'S') ? 'SI' : 'NO' }
                ]
            } else return []
        },
        itemsDatosProfesionales(state) {
            if (Object.keys(state.datosProfesionales).length > 0) {
                return [
                    { "NRO. MATRÍCULA": state.matricula },
                    { "FECHA DE EXPEDICIÓN DE TÍTULO": state.datosProfesionales.fectit },
                    { "FECHA DE MATRICULACÍON": state.datosProfesionales.fecmat },
                    { "TOMO": state.datosProfesionales.tomo },
                    { "FOLIO": state.datosProfesionales.folio }
                ]
            } else return []
        },
        itemsDatosNivel(state) {
            if (Object.keys(state.datosNivel).length > 0) {
                return [
                    { "TU OPCIÓN DE NIVEL": (state.datosNivel.reducido) ? state.itemReduce[0].text_completo : state.datosNivel.nivel },
                    { "EMPLEADOR": state.datosNivel.empleo },
                    { "TIPO DE EMPLEO": state.datosNivel.empleoTipo },
                    { "FECHA DE INICIO DE ACTIVIDAD": state.datosNivel.empleoDesde },
                    //  { "JUBILADO": ((state.datosNivel.esJubilado) == 'S') ? 'SI' : "NO" }
                ]
            } else return []
        },
        itemsDatosHijos(state) {
            if (state.datosHijos.length > 0) {
                return state.datosHijos.map((item, index) => {
                    return [
                        { "NOMBRE Y APELLIDO": `${item.nombres} ${item.apellido}` },
                        { "DNI": item.nrodoc },
                        { "SEXO": item.sexo },
                        { "FECHA DE NACIMIENTO": item.fecnacim },
                        { "DISCAPACIDAD": ((item.discapacidad) == 'S') ? 'SI' : 'NO' }
                    ]
                })
            } else return []
        },

    },
    mutations: {
        setCantHijos(state, payload) {
            state.cantHijos = payload
        },
        setDatosPadres(state, payload) {
            state.datosPadres = { datosPadre: payload.padre, datosMadre: payload.madre }
        },
        setCargaConyuge(state, payload) {
            state.cargaConyuge = payload
        },
        setItemReduce(state) {
            state.itemReduce = []
        },
        setPreAfi(state, payload) {
            state.preafi = payload
        },
        setFototmp(state, fototmp) {
            state.fototmp = fototmp
            //state.datosPersonales.fotocarnet = fototmp
        },
        setFotoCarnet(state) {
            state.fotocarnet = state.fototmp
            //state.datosPersonales.fotocarnet = ''
            /*             if (state.fototmp !== '') {
                            state.fotocarnet = state.fototmp
                        } */
        },
        deleteFotoCarnet(state) {
            state.fotocarnet = ''
        },
        setDatosNivel(state, payload) {
            state.datosNivel = payload
        },
        setDatosRegimenDiscapacidad(state, payload) {
            state.datosPersonales.fecdisc = payload.fecdisc
            state.datosPersonales.feccud = payload.feccud
        },
        setMatriculaDni(state, payload) {
            state.matricula = payload.nroafi
            state.datosPersonales.nrodoc = payload.nrodni
            state.nrodoc = payload.nrodni
        },
        setDatosPersonales(state, payload) {
            state.datosPersonales = payload
            state.fecnacim = state.datosPersonales.fecnacim
            state.datosPersonales.fotocarnet = state.fotocarnet
        },
        setDatosHijos(state, payload) {
            state.datosHijos = payload
        },
        setDatosProfesionales(state, payload) {
            state.datosProfesionales = payload
        },
        setDatosContacto(state, payload) {
            state.datosContacto = payload
        },
        setDatosFamiliares(state, payload) {
            state.datosFamiliares = payload
        },
        setIdEstadoCivil(state, payload) {
            state.idEstadoCivil = payload
        },
        setFechaNacim(state, payload) {
            state.fecnacim = payload
        },
        setFechaEstadoCivil(state, payload) {
            state.fechaEstadoCivil = payload
        },
        setFechaTitulo(state, payload) {
            state.fectit = payload
        },
        setFechaMatricula(state, payload) {
            state.fecmat = payload
        },
        editarItem(state, payload) {
            state.itemNivel.push(payload)
        },
        setFechaAfi(state, payload) {
            state.fecafil = payload
        },
        borrarArchivo(state, payload) {
            switch (payload.op) {
                case 'personales':
                    state.archPersonales1.splice(payload.index, 1)
                    break;
                case 'profesionales1':
                    state.archProfesionales1.splice(payload.index, 1)
                    break;
                case 'profesionales2':
                    state.archProfesionales2.splice(payload.index, 1)
                    break;
                case 'profesionales3':
                    state.archProfesionales3.splice(payload.index, 1)
                    break;
                case 'familiares1':
                    state.archFamiliares1.splice(payload.index, 1)
                    break;
                case 'familiares2':
                    state.archFamiliares2.splice(payload.index, 1)
                    break;
                case 'niveles1':
                    state.archNiveles1.splice(payload.index, 1)
                    break;
                case 'niveles2':
                    state.archNiveles2.splice(payload.index, 1)
                    break;
            }
        },
        setArchivos(state, payload) {
            if (payload.op.includes('Hijo')) {
                const match = payload.op.match(/\d+/);
                if (!match) return; // Evitar errores si no se encuentra un número

                const index = parseInt(match[0], 10) - 1;
                const keyMap = {
                    [`dniFrenteHijo${index + 1}`]: 'dniFrenteHijo',
                    [`dniDorsoHijo${index + 1}`]: 'dniDorsoHijo',
                    [`certDiscHijo${index + 1}`]: 'certDiscHijo',
                    [`partidaNacHijo${index + 1}`]: 'partidaNac',
                };

                const key = keyMap[payload.op];
                if (!key) return; // Si la clave no es válida, no hacer nada

                if (!state.archivosHijos[index]) {
                    state.archivosHijos[index] = {}; // Inicializar si no existe
                }

                state.archivosHijos[index] = {
                    ...state.archivosHijos[index],
                    [key]: payload.file || ''
                };
            }
            else {
                switch (payload.op) {
                    case 'dniFrentePreAfiliado':
                        (payload.file !== '') ? state.dniFrentePreAfiliado = [payload.file] : state.dniFrentePreAfiliado = []
                        break;
                    case 'dniDorsoPreAfiliado':
                        (payload.file !== '') ? state.dniDorsoPreAfiliado = [payload.file] : state.dniDorsoPreAfiliado = []
                        break;
                    case 'personales':
                        (payload.file !== '') ? state.archPersonales1 = state.archPersonales1.concat(payload.file) : state.archPersonales1 = []
                        break;
                    case 'titFrenteAfiliado':
                        (payload.file !== '') ? state.titFrenteAfiliado = state.titFrenteAfiliado.concat(payload.file) : state.titFrenteAfiliado = []
                        break;
                    case 'titDorsoAfiliado':
                        (payload.file !== '') ? state.titDorsoAfiliado = state.titDorsoAfiliado.concat(payload.file) : state.titDorsoAfiliado = []
                        break;
                    case 'histMatricula':
                        (payload.file !== '') ? state.histMatricula = state.histMatricula.concat(payload.file) : state.histMatricula = []
                        break;
                    case 'certMatricula':
                        (payload.file !== '') ? state.certMatricula = state.certMatricula.concat(payload.file) : state.certMatricula = []
                        break;
                    case 'dniFrenteFamiliar':
                        (payload.file !== '') ? state.dniFrenteFamiliar = state.dniFrenteFamiliar.concat(payload.file) : state.dniFrenteFamiliar = []
                        break;
                    case 'dniDorsoFamiliar':
                        (payload.file !== '') ? state.dniDorsoFamiliar = state.dniDorsoFamiliar.concat(payload.file) : state.dniDorsoFamiliar = []
                        break;
                    case 'certDisc':
                        if (payload.file !== '') {
                            if (state.certDisc.length < 2) {
                                state.certDisc.push(payload.file)
                            } else {
                                state.certDisc.pop()
                                state.certDisc.push(payload.file)
                            }
                        } else
                            state.certDisc.pop()
                        break;
                    case 'cudOriginal':
                        (payload.file !== '') ? state.cudOriginal = state.cudOriginal.concat(payload.file) : state.cudOriginal = []
                        break;
                    case 'certDiscFamiliar':
                        (payload.file !== '') ? state.certDiscFamiliar = state.certDiscFamiliar.concat(payload.file) : state.certDiscFamiliar = []
                        break;
                    case 'certDefuncionFamiliar':
                        (payload.file !== '') ? state.certDefuncionFamiliar = state.certDefuncionFamiliar.concat(payload.file) : state.certDefuncionFamiliar = []
                        break;
                    case 'certMatConConvFamiliar':
                        (payload.file !== '') ? state.certMatConConvFamiliar = state.certMatConConvFamiliar.concat(payload.file) : state.certMatConConvFamiliar = []
                        break;
                    case 'reciboSueldo':
                        (payload.file !== '') ? state.reciboSueldo = state.reciboSueldo.concat(payload.file) : state.reciboSueldo = []
                        break;
                    case 'certLaboral':
                        (payload.file !== '') ? state.certLaboral = state.certLaboral.concat(payload.file) : state.certLaboral = []
                        break;
                }

            }
        },
        setReducido(state, payload) {
            state.aporteReducido = payload
        },
        setResumen(state, payload) {
            state.resumen = payload
        },
        setReconsidera(state, payload) {
            state.reconsidera = payload
        },
        setTotalAnios(state, payload) {
            state.totalAnios = payload
            state.tipoAporteRed = Object.values(payload).flatMap(arr => arr).find(item => item.mjo_tipo !== undefined).mjo_tipo
            switch (state.tipoAporteRed) {
                case 1:
                    state.itemReduce.push({ value: 6, text: 'PMJ', text_completo: 'PLAN MÓDULO JOVEN', nivel: 2, tip_apo: 1, reduce: 1, parrafo: "Este beneficio es optativo y puede ser solicitado por los jóvenes colegas, recién graduados. Consiste en una aportación reducida sobre el nivel 2, hasta los 34 años de edad inclusive, siempre que al momento de matricularse no superen los 32 años." },)
                    break;
                case 2:
                    state.itemReduce.push({ value: 7, text: 'RAR', text_completo: 'RÉGIMEN DE APORTACIÓN REDUCIDA', nivel: 2, tip_apo: 2, reduce: 1, parrafo: "Este beneficio es optativo y puede ser solicitado por la Profesional Psicóloga/o al momento de afiliarse a la Caja, desde los 33 años de edad en adelante y siempre que no exceda los 3 años desde la fecha de expedición de su título de grado universitario." },)
                    break;
                default:
                    state.itemReduce = []
                    break;
            }
        },
        setTablaAporteReducido(state, payload) {
            state.tablaAporteReducido = payload
        },
        setObjNivel(state, payload) {
            state.objNivel = payload
        },
        setNecesitaHistorial(state, payload) {
            state.necesitaHistorial = payload
        },
        setArrayHijos(state, payload) {
            const numHijos = Number(payload);
            if (!Number.isInteger(numHijos) || numHijos < 0) return; // Validación

            if (state.archivosHijos.length !== numHijos) {
                state.archivosHijos = Array.from({ length: numHijos }, () => ({
                    dniFrenteHijo: '',
                    dniDorsoHijo: '',
                    certDiscHijo: '',
                    partidaNac: ''
                }));
            }
        },
        setMsgPreAfiliacion(state, payload) {
            state.resPreAfiliacion = payload
        },


        /*         setArrayHijos(state, payload) {
                    state.archivosHijos = Array.from({ length: payload }, () => ({}))
                } */
    },
    actions: {
        //guardado de datos
        //
        guardarCantHijos({ commit }, payload) {
            //segun la cantidad de hijos almacena los objetos hijos en un array.
            //si hay 1 lo deja como objeto, si hay mas de 1 lo almacena en un array
            commit('setCantHijos', payload)
            commit('setArrayHijos', payload)
        },
        guardarMatriculaDni({ commit }, payload) {
            commit('setMatriculaDni', payload)
        },
        guardarDatosPersonales({ commit, dispatch }, payload) {
            //al momento de guardar datos personales almacena la fecha de nacimiento en setDatosPersonales
            commit('setDatosPersonales', payload)
        },
        guardarDatosHijos({ commit }, payload) {
            commit('setDatosHijos', payload)
        },
        guardarDatosNivel({ commit }, payload) {
            commit('setDatosNivel', payload)
        },
        guardarDatosProfesionales({ commit }, payload) {
            commit('setDatosProfesionales', payload)
        },
        guardarDatosPadres({ commit }, payload) {
            commit('setDatosPadres', payload)
        },
        guardarDatosDiscapacidad({ commit }, payload) {
            commit('setDatosDiscapacidad', payload)
        },
        guardarDatosRegimenDiscapacidad({ commit }, payload) {
            commit('setDatosRegimenDiscapacidad', payload)
        },
        guardarDatosContacto({ commit }, payload) {
            commit('setDatosContacto', payload)
        },
        guardarDatosConyuge({ commit }, payload) {
            commit('setDatosFamiliares', payload)
        },
        saveIdEstadoCivil({ commit }, payload) {
            commit('setIdEstadoCivil', payload)
        },
        //guardado de fechas
        guardarFechaNacim({ commit }, payload) {
            commit('setFechaNacim', payload)
        },
        guardarFechaEstadoCivil({ commit }, payload) {
            commit('setFechaEstadoCivil', payload)
        },
        guardarFechaMatricula({ commit }, payload) {
            commit('setFechaMatricula', payload)
        },
        guardarFechaTitulo({ commit }, payload) {
            commit('setFechaTitulo', payload)
        },
        guardarFechaAfi({ commit }, payload) {
            commit('setFechaAfi', payload)
        },

        //evaluar nivel 1
        async evaluarNivel1({ commit, dispatch, state }, payload) {
            try {
                const response = await axios({
                    method: 'post',
                    url: process.env.VUE_APP_API + 'afiliacion/nivel/evaluarOpcionNivel1',
                    withCredentials: false,
                    data: payload,
                    headers: {
                        "Content-Type": "application/json",
                    },
                });
                const res = response.data;
                if (res.evaluacion.nivel1) {
                    return true;
                } else {
                    dispatch('notificaciones/showSnack',
                        {
                            message: res.evaluacion.mensaje,
                            type: '400'
                        }, { root: true });
                }
                return false;
            } catch (error) {
                console.error('Error occurred:', error);
                dispatch('notificaciones/showSnack',
                    {
                        message: error.response?.data?.mensaje || error.message || 'Ocurrió un error',
                        type: '400'
                    }, { root: true });
                //return false;
            }
        },

        //guardado de archivos InputArchivos
        addFilesPre({ commit }, payload) {
            commit('setArchivos', payload)
        },
        deleteFilesPre({ commit }, payload) {
            commit('setArchivos', payload)
        },
        deleteItemPre({ commit }, payload) {
            commit('borrarArchivo', payload)
        },
        //almacena la fototmp en fotoCarnet
        guardarPreFotoCarnet({ commit }) {
            commit('setFotoCarnet')
        },
        // foto carnet
        addFotoCarnet({ commit }, payload) {
            commit('setFototmp', payload)
        },
        deleteFotoCarnet({ commit }) {
            commit('deleteFotoCarnet')
        },
        // editar array itemNivel
        addItemNivel({ commit }, payload) {
            commit('editarItem', payload)
        },
        removeItemNivel({ commit }, payload) {
            commit('editarItem', payload)
        },
        async getOpcionNivel({ commit, dispatch, state }) {
            await axios({
                method: 'post',
                url: process.env.VUE_APP_API + 'afiliacion/nivel/obtenerAporteReducido',
                withCredentials: false,
                data: JSON.stringify({
                    nroafi: parseInt(state.matricula),
                    fecnacim: state.fecnacim,
                    fecmat: state.datosProfesionales.fecmat,
                    fecafil: (new Date()).toJSON().slice(0, 10),
                    fectit: state.datosProfesionales.fectit,
                }),
                headers: {
                    "Content-Type": "application/json",
                },
            }).then(function (response) {
                const res = response.data;
                if (Object.keys(res).length == 3) {
                    commit('setObjNivel', res)

                    // Guardar en resumen el objeto "2" si existe, si no el "1"
                    let resumenPreferido = null;
                    if (res.resumen) {
                        if (res.resumen["2"]) {
                            resumenPreferido = res.resumen["2"];
                            commit('setReconsidera', true)
                        } else if (res.resumen["1"]) {
                            resumenPreferido = res.resumen["1"];
                            commit('setReconsidera', false)
                        }
                    }
                    commit('setResumen', [resumenPreferido])
                    commit('setTotalAnios', res.totalAnios)
                    commit('setTablaAporteReducido', res.tablaReferenciaAporteReducido)
                    commit('setReducido', (state.datosPersonales.tramita_discapacidad !== 'S'))
                }
                else if ((Object.keys(res).length == 2)) {
                    commit('setReducido', false)
                }
            }).catch(function (error) {
                console.log(error);
            })
        },
        crearFormData({ state, dispatch }) {
            const options = {
                indices: true,
                nullsAsUndefineds: false,
                booleansAsIntegers: false,
                allowEmptyArrays: false,
                noFilesWithArrayNotation: false,
                dotsForObjectNotation: false,
            }
            //almaceno los datos del afiliado solamente en el formData y
            //despues tengo que incluir los archivos con las etiquetas que puse en dataUser
            let data = {
                datosPersonales: state.datosPersonales,
                datosContacto: state.datosContacto,
                datosFamiliares: [],
                /* 
                datosDiscapacidad: state.datosRegimenDiscapacidad,
                datosFamiliares: [state.datosFamiliares, state.datosPadres.datosPadre, state.datosPadres.datosMadre, ...state.datosHijos], */
                datosProfesionales: state.datosProfesionales,
                datosDiscapacidad: state.datosDiscapacidad,
                datosNivel: state.datosNivel
            }
            if (state.datosFamiliares) {
                data.datosFamiliares.push(state.datosFamiliares)
            };
            if (state.datosPadres) {
                data.datosFamiliares.push(state.datosPadres.datosPadre)
                data.datosFamiliares.push(state.datosPadres.datosMadre)
            };
            if (state.datosHijos.length > 0) {
                data.datosFamiliares.push(...state.datosHijos)
            };
            state.formData = serialize(
                data,
                options, // optional
            );
            if (state.dniFrentePreAfiliado && state.dniDorsoPreAfiliado) {
                state.formData.append('afiliado_archivos[apa_dni_frente]', state.dniFrentePreAfiliado[0])
                state.formData.append('afiliado_archivos[apa_dni_dorso]', state.dniDorsoPreAfiliado[0])
            }
            if (state.datosFamiliares) {
                if (state.dniFrenteFamiliar && state.dniDorsoFamiliar) {
                    state.formData.append('familiar_archivos[apf_dni_frente]', state.dniFrenteFamiliar[0])
                    state.formData.append('familiar_archivos[apf_dni_dorso]', state.dniDorsoFamiliar[0])
                }
                if (state.certMatConConvFamiliar) state.formData.append('familiar_archivos[apf_cert]', state.certMatConConvFamiliar[0])
                if (state.certDiscFamiliar) state.formData.append('familiar_archivos[apf_cert_discap]', state.certDiscFamiliar[0])
            }
            if (state.titFrenteAfiliado && state.titDorsoAfiliado) {
                state.formData.append('afiliado_archivos[apa_titulo_frente]', state.titFrenteAfiliado[0])
                state.formData.append('afiliado_archivos[apa_titulo_dorso]', state.titDorsoAfiliado[0])
            }
            if (state.histMatricula) state.formData.append('afiliado_archivos[apa_hist_mat]', state.histMatricula[0])
            if (state.certDisc.length < 3) {
                state.formData.append('discapacidad_archivos[apa_cert_disc]', state.certDisc[0])
                state.formData.append('discapacidad_archivos[apa_cud_original]', state.certDisc[1])
            }
            // if (state.cudOriginal) state.formData.append('discapacidad_archivos[apa_cud_original]', state.cudOriginal[0])
            if (state.certMatricula) state.formData.append('afiliado_archivos[apa_cert_mat]', state.certMatricula[0])

            if (state.reciboSueldo) state.formData.append('nivel_archivos[apa_recibo_sueldo]', state.reciboSueldo[0])
            if (state.certLaboral) state.formData.append('nivel_archivos[apa_cert_laboral]', state.certLaboral[0])
            if (state.archivosHijos.length > 0) {
                state.archivosHijos.forEach((item, index) => {
                    if (item.dniFrenteHijo) state.formData.append(`familiar_archivos[dniFrenteHijo${index}]`, item.dniFrenteHijo)
                    if (item.dniDorsoHijo) state.formData.append(`familiar_archivos[$dniDorsoHijo${index}]`, item.dniDorsoHijo)
                    if (item.certDiscHijo) state.formData.append(`familiar_archivos[certDiscHijo${index}]`, item.certDiscHijo)
                    if (item.partidaNac) state.formData.append(`familiar_archivos[partidaNac${index}]`, item.partidaNac)
                })
            }


            //dispatch('notificaciones/startLoading', null, { root: true })
            //dispatch('cargaNuevoAfiliado', formData)
        },

        async cargaNuevoAfiliado({ state, commit, dispatch }) {
            let success = false;
            try {
                const response = await axios({
                    method: 'post',
                    url: process.env.VUE_APP_API + 'afiliacion/guardarAfiliacion',
                    withCredentials: false,
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                    data: state.formData,
                    timeout: TIMEOUT_ENVIO_AFILIACION,
                });
                const res = response.data
                if (res.success) {
                    dispatch('notificaciones/showSnack',
                        {
                            message: 'Solicitud de afiliación enviada correctamente.',
                            type: (response.status).toString()
                        }, { root: true })
                    commit('setMsgPreAfiliacion', { msg: res.msg, detalle: res.detalle, success: res.success })
                } else {
                    commit('setMsgPreAfiliacion', { msg: res.msg, detalle: res.detalle, success: res.success })
                }
                success = true
            } catch (error) {
                console.error('Error al enviar la afiliación:', error)
                commit('setMsgPreAfiliacion', mensajeErrorEnvioAfiliacion(error))
                /*
                    Devolvemos true aunque el envio haya fallado: la vista solo
                    abre el dialogo de resultado cuando recibe true. Con false
                    el overlay se cerraba sin mostrar nada y la afiliada se
                    quedaba sin saber que paso.
                    El dialogo en modo error solo ofrece CERRAR, que resuelve
                    false y devuelve el stepper al paso 1 sin borrar los datos.
                 */
                success = true
            } finally {
                //dispatch('borrarDatosAfiliacion')
            }
            return success
        },

        /* ¿?¿? */
        setValPreAfi({ commit, dispatch }, payload) {
            commit('setPreAfi', payload)
        },

        async getValidarAfiliado({ state, commit, dispatch }, data) {
            await axios({
                method: 'post',
                url: process.env.VUE_APP_API + 'afiliacion/validacion/validarMatricula',
                headers: {
                    "Content-Type": "application/json",
                },
                withCredentials: false,
                data: JSON.stringify({
                    nroafi: data.nroafi,
                    dniafi: data.nrodni
                }),
            }).then(function (response) {
                switch (response.data[0].codigo) {
                    case 1:
                        commit('setPreAfi', true)
                        dispatch('guardarMatriculaDni', data)
                        //dispatch('common/levantarCommon', null, { root: true })
                        router.push('/FormularioAfiliacion').catch(() => { })
                        break;
                    case 2:
                        dispatch('notificaciones/showSnack', {
                            message: response.data[0].msg,
                            type: "500",
                        }, { root: true })
                        break;
                    default:
                        dispatch('notificaciones/showSnack', {
                            message: response.data[0].msg,
                            type: '400',
                        }, { root: true })
                        break;
                }
            }).catch(function (error) {
                console.log(error);
                /*                 dispatch('notificaciones/showSnack', {
                                    message: error.response.data.message,
                                    type: (error.response.status).toString(),
                                }, { root: true }) */
            })

        },
        async getValidarFechaMatricula({ commit, dispatch, state }, data) {
            await axios({
                method: 'post',
                url: process.env.VUE_APP_API + 'afiliacion/validacion/validarFechaMatricula',
                headers: {
                    "Content-Type": "application/json",
                },
                withCredentials: false,
                data: JSON.stringify({
                    nroafi: state.matricula,
                    fecmat: data
                }),
            }).then(function (response) {
                const res = response.data[0]
                if (res.msg !== null) {
                    dispatch('notificaciones/showSnack',
                        {
                            message: res.msg,
                            cerrar: true,
                            type: '400'
                        }, { root: true })
                }
                if (res.dias_habiles > 30) commit('setNecesitaHistorial', true)
                else commit('setNecesitaHistorial', false)
            }).catch(function (error) {
                dispatch('notificaciones/showSnack',
                    {
                        message: error.success,
                        type: '400'
                    }, { root: true })
                router.push('/login').catch(() => { })
            })
        },
        async getSipre({ commit, dispatch }) {
            await axios({
                method: 'get',
                url: 'https://apps-caja.cajapsipba.org.ar/nuevosipreapi/',
                withCredentials: false,
            })
                .then(function (response) {
                    const res = response.data.message
                })
                .catch(function (error) {
                }).finally(() => {
                    //dispatch('auth/setSktLoader', false, { root: true })
                });
        },
        defaultItemReduce({ state, commit, dispatch }) {
            commit('setItemReduce')
        },
        borrarDatosAfiliacion({ dispatch, commit }) {
            dispatch('guardarDatosPersonales', {})
            dispatch('guardarDatosConyuge', {})
            dispatch('guardarDatosContacto', {})
            dispatch('guardarDatosNivel', {})
            dispatch('guardarDatosProfesionales', {})
            // Vaciar archivos cargados
            commit('setArchivos', { op: 'dniFrentePreAfiliado', file: '' })
            commit('setArchivos', { op: 'dniDorsoPreAfiliado', file: '' })
            commit('setArchivos', { op: 'titFrenteAfiliado', file: '' })
            commit('setArchivos', { op: 'titDorsoAfiliado', file: '' })
            commit('setArchivos', { op: 'histMatricula', file: '' })
            commit('setArchivos', { op: 'certMatricula', file: '' })
            commit('setArchivos', { op: 'dniFrenteFamiliar', file: '' })
            commit('setArchivos', { op: 'dniDorsoFamiliar', file: '' })
            commit('setArchivos', { op: 'certMatConConvFamiliar', file: '' })
            commit('setArchivos', { op: 'certDisc', file: '' })
            commit('setArchivos', { op: 'cudOriginal', file: '' })
            commit('setArchivos', { op: 'certDiscFamiliar', file: '' })
            commit('setArchivos', { op: 'certDefuncionFamiliar', file: '' })
            commit('setArchivos', { op: 'reciboSueldo', file: '' })
            commit('setArchivos', { op: 'certLaboral', file: '' })
            // Vaciar archivos de hijos
            commit('setArrayHijos', 0)
            // Vaciar fotocarnet
            commit('deleteFotoCarnet')
        },
    }
})